<!--
 * @Author: andy_chen
 * @created: 2018-11-13 15:57:46
-->

<template>
    <div class="container">
        <section class="intro">
            <img class="logo" src="../assets/public/logo_512.png" alt>
            <p class="app-name">旅喵结伴</p>
            <p class="app-desc">专业的旅行结伴APP，约不到算我输</p>
        </section>
        <section class="lightspot-section">
            <div class="section-logo">
                <img class="logo" src="../assets/aboutus/travel-icon.png" alt>
            </div>
            <p class="section-title">
                <span>对旅行的重新定义</span>
            </p>
            <div class="section-detail">
                <p>在这里，你是旅行的发起者，也是参与者！</p>
                <p>自由结伴，随心同行！</p>
            </div>
            <div class="section-image-box">
                <img src="../assets/aboutus/travel.jpg" alt>
            </div>
        </section>
        <section class="lightspot-section">
            <div class="section-logo">
                <img class="logo" src="../assets/aboutus/share-icon.png" alt>
            </div>
            <p class="section-title">
                <span>随手分享快乐同享</span>
            </p>
            <div class="section-detail">
                <p>千万驴友告诉你全世界最好玩的地方在哪里，随时随地分享旅途趣事，发现新奇、有趣、好玩的地方，轻松捕捉下一次旅行的灵感。</p>
            </div>
            <div class="section-image-box">
                <img src="../assets/aboutus/share.jpg" alt>
            </div>
        </section>
        <section class="lightspot-section">
            <div class="section-logo">
                <img class="logo" src="../assets/aboutus/friend-icon.png" alt>
            </div>
            <p class="section-title">
                <span>丰富的旅行社交圈</span>
            </p>
            <div class="section-detail">
                <p>在旅喵结伴上结识旅游达人，让“老司机”带你一起探索世界上最新奇、最好玩的每一个角落！结交更多好伙伴！</p>
            </div>
            <div class="section-image-box">
                <img src="../assets/aboutus/friend.jpg" alt>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "AboutUs",
    components: {},
    data() {
        return {};
    },

    mounted() {},

    computed: {},

    methods: {}
};
</script>

<style scoped lang="scss">
@import "../style/function.scss";
@import "../style/config.scss";

input {
    background: #ffffff;
    box-sizing: border-box;
    width: 100%;
    outline: none;
    border: none;
    // /*去除系统默认的样式*/
    -webkit-appearance: none;
    // /* 点击高亮的颜色*/
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.container {
    background: #fff;
}

.intro {
    width: 100%;
    height: 6rem;
    background: url("../assets/aboutus/bg.png") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    padding-top: 0.52rem;
    box-sizing: border-box;
    margin-bottom: -2rem;
    padding-bottom: 2rem;
    .logo {
        width: 1.6rem;
        height: 1.6rem;
        margin-bottom: 0.16rem;
    }

    .app-name {
        color: $baseColor;
        font-weight: bold;
        margin-bottom: 0.2rem;
        font-size: 0.32rem;
        line-height: 0.45rem;
    }

    .app-desc {
        color: $baseColor;
        font-size: 0.28rem;
        line-height: 0.4rem;
    }
}

.lightspot-section {
    margin-bottom: 0.52rem;

    &:last-child {
        margin-bottom: 0;
    }
}

.section-logo {
    width: 1rem;
    height: 1rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
    > img {
        width: 100%;
        height: 100%;
    }
}

.section-title {
    text-align: center;
    padding-top: 0.38rem;
    padding-bottom: 0.38rem;
    font-size: 0.32rem;
    position: relative;

    & > span {
        position: relative;
    }

    & > span:before {
        right: 100%;
        margin-right: 0.1rem;
        background: linear-gradient(
            to right,
            rgba(192, 192, 192, 0),
            rgba(51, 51, 51, 0.9)
        ); /* 标准的语法 */
    }

    & > span:after {
        left: 100%;
        margin-left: 0.1rem;
        background: linear-gradient(
            to right,
            rgba(51, 51, 51, 0.9),
            rgba(192, 192, 192, 0)
        ); /* 标准的语法 */
    }

    & > span:before,
    & > span:after {
        content: " ";
        position: absolute;
        top: 50%;
        margin-top: -0.5px;
        width: 1.1rem;
        height: 1px;
    }
}

.section-detail {
    font-size: 0.32rem;
    color: $baseColor;
    line-height: 0.54rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
}

.section-image-box {
    margin-top: 0.52rem;
    & > img {
        width: 100%;
        display: block;
    }
}
</style>
